import {createContext} from 'react'

const FacturaContext = createContext()

export default FacturaContext